import React from "react";
import Slider from "react-slick";

const base = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public";
const slides = [
  // Main Slider
  {
    img: "slider1.jpg",
    captionTitle: null,
    captionYear: null,
  },

  // AIR FORCE DAY
  {
    img: "slider28.jpg",
    captionTitle: "AIR FORCE DAY",
    captionYear: "2026",
  },
  {
    img: "slider29.jpg",
    captionTitle: "AIR FORCE DAY",
    captionYear: "2026",
  },

  {
    img: "slider30.jpg",
    captionTitle: "AIR FORCE DAY",
    captionYear: "2026",
  },

  // Sports Day 2026
  {
    img: "slider16.jpg",
    captionTitle: "SPORTS DAY",
    captionYear: "2026",
  },
  {
    img: "slider24-1.jpg",
    captionTitle: "SPORTS DAY",
    captionYear: "2026",
  },

  {
    img: "slider15.jpg",
    captionTitle: "SPORTS DAY",
    captionYear: "2026",
  },

  {
    img: "slider18.jpg",
    captionTitle: "SPORTS DAY",
    captionYear: "2026",
  },

  {
    img: "slider14.jpg",
    captionTitle: "SPORTS DAY",
    captionYear: "2026",
  },

  {
    img: "slider17.jpg",
    captionTitle: "SPORTS DAY",
    captionYear: "2026",
  },

  {
    img: "slider27.jpg",
    captionTitle: "SPORTS DAY",
    captionYear: "2026",
  },
  // Annual Prize Distribution 2026
  {
    img: "slider23.jpg",
    captionTitle: "ANNUAL PRIZE DISTRIBUTION",
    captionYear: "2026",
  },
  {
    img: "slider24.jpg",
    captionTitle: "ANNUAL PRIZE DISTRIBUTION",
    captionYear: "2026",
  },
  {
    img: "slider25.jpg",
    captionTitle: "ANNUAL PRIZE DISTRIBUTION",
    captionYear: "2026",
  },

  // Annual Athletic Meet 2026
  {
    img: "slider19.jpg",
    captionTitle: "ANNUAL ATHLETIC MEET",
    captionYear: "2026",
  },
  {
    img: "slider20.jpg",
    captionTitle: "ANNUAL ATHLETIC MEET",
    captionYear: "2026",
  },

  // Investiture Ceremony 2026
  {
    img: "slider21.jpg",
    captionTitle: "INVESTITURE CEREMONY",
    captionYear: "2026",
  },
  {
    img: "slider22.jpg",
    captionTitle: "INVESTITURE CEREMONY",
    captionYear: "2026",
  },

  // Raising Day 2026
  {
    img: "slider2.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider3.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider4.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider5.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider6.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider7.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider8.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider9.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider10.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider11.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider12.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
  {
    img: "slider13.jpg",
    captionTitle: "RAISING DAY",
    captionYear: "2026",
  },
];

const HomeSlider = () => {
  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    adaptiveHeight: true,
  };
  return (
    <>
      <div className="slider-sec">
        <Slider {...settings}>
          {slides.map((s, i) => (
            <div className="slider-item" key={i}>
              <img
                src={base + `/Images/${s.img}`}
                className="d-block w-100"
                alt="The Air Force School"
              />
              {(s.captionTitle || s.captionYear) && (
                <div className="slider-caption">
                  {s.captionTitle && (
                    <span className="caption-title">{s.captionTitle}</span>
                  )}
                  {s.captionYear && (
                    <span className="caption-year">{s.captionYear}</span>
                  )}
                </div>
              )}
            </div>
          ))}
        </Slider>
        <div className="thought">
          <div>
            <div className="thoughtimg">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/though.png"
                className="img-fluid"
                alt="The Air Force School"
              />
            </div>
            <h4>
              Learn from Yesterday, Live for Today, hope for tomorrow{" "}
              <span> Albert Einstein </span>{" "}
            </h4>
          </div>
        </div>
        <div className="mission">
          <div className="missionimg">
            {" "}
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/mision.png"
              className="img-fluid"
              alt="The Air Force School"
            />
            <div className="missiondesc">
              {" "}
              <p>
                “to develop our students into responsible, harmonious and
                integrated individuals through ever evolving curricular and
                co-curricular activities”
              </p>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;
